import React, { useEffect } from 'react';
import { Box, useTheme } from "@mui/material";
import { tokens } from '../../../theme';
import NumberInput from "./NumberInput";
import cx from 'classnames';
import Text from '../text/Text';

const ShValidatedNumberInput = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box 
            sx={{width:1}}
        >
            <Box
                className={cx(props.className, {
                    'error': typeof props.error !== "undefined" && props.error.length > 0,
                })}
                sx={{
                    flex:1,
                    backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                    borderRadius:5,
                    display:"flex",
                    ...props.sx,
                }}
            >
                <NumberInput 
                    min={props.min ?? null} 
                    max={props.max ?? null} 
                    btnSize={props.btnSize} 
                    onlyPositive={props.onlyPositive ?? false}
                    onlyNegative={props.onlyNegative ?? false}
                    value={props.value}
                    change={(e) => props.onChange(props.name, e)}
                    error={Boolean(props.error)}
                    inputSX={props.inputSX ?? null}
                    disabled={props.disabled ?? false}
                />
            </Box>
            {typeof props.error !== "undefined" && props.error.length > 0 &&
                <Box
                    sx={{
                        pl:2,
                    }}
                >
                    <Text bold variant="red">{props.error}</Text>    
                </Box>
            }
        </Box>
    );
};

export default ShValidatedNumberInput;